const KitlookPlusIcon = () => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 18.3333V8.33331H21.6666V18.3333H31.6666V21.6666H21.6666V31.6666H18.3333V21.6666H8.33325V18.3333H18.3333Z"
      fill="#001018"
    />
  </svg>
)

export default KitlookPlusIcon
